export default __webpack_public_path__ + "static/media/autocarros.c7a17161.png";